interface OutputMetadata {
  sources: {
    avif: string;
    webp: string;
  };
  img: {
    src: string;
    w: number;
    h: number;
  };
}

export function Picture({
  src,
  alt,
  pictureProps,
  ...props
}: Omit<React.ComponentProps<"img">, "src"> & {
  src: OutputMetadata;
  pictureProps?: React.ComponentProps<"picture">;
}) {
  return (
    <picture {...pictureProps}>
      {Object.entries(src.sources).map(([format, src]) => (
        <source
          srcSet={src}
          type={`image/${format}`}
          key={`${src}-${format}`}
        />
      ))}
      <img
        src={src.img.src}
        alt={alt}
        width={src.img.w}
        height={src.img.h}
        loading="lazy"
        decoding="async"
        {...props}
      />
    </picture>
  );
}
